export default "__VITE_ASSET__D9gpXZAf__"